import React, {useState, useEffect} from 'react';
import {useHistory, useLocation} from 'react-router-dom'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Divider from '@material-ui/core/Divider';
import {makeStyles} from "@material-ui/core/styles";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import {ThemeProvider} from "@material-ui/styles";
import PropTypes from "prop-types";
import StarIcon from '@material-ui/icons/Star';
import IconButton from '@material-ui/core/IconButton';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

const useStyles = makeStyles((theme) => ({
    imageIcon: {
        width: '10vw',
        height: '10vw',
        maxWidth: 35,
        maxHeight: 35,
        backgroundColor: 'transparent',
    },
    color: {
        color: '#011238',
    },
    noSpaces: {
        marginBottom: '-1px',
        padding: 0,
        border: 'solid 1px',
        borderColor: '#011238'
    },
    noSpacesMobile: {
        margin: 0,
        maxWidth: '98vw',
        padding: 0
    }
}));

const theme = createMuiTheme({
    typography: {
        fontFamily: [
            '"Lato"',
            '"Roboto"',
            'sans-serif'
        ].join(','),
    },
    palette: {
        primary: {
            main: '#28C339'
        },
        secondary: {
            main: '#315268'
        }
    },
});

function ListItemLink(props) {
    return <ListItem button component="a" {...props} />;
}

const MainTitleBox = ({infoRow, isMobile}) => {
    const classes = useStyles();

    const [imageIconUse, setImageIconUse] = useState(null)

    const history = useHistory()
    let location = useLocation()
    const url = location.pathname;

    const changeUrl = () => {
        if(infoRow.urltitle.includes('http')){
            window.open(infoRow.urltitle)
        } else {
            history.push(infoRow.urltitle)
        }
    }

    useEffect(() => {

        if(infoRow.icon !== undefined && url.indexOf('/') === url.lastIndexOf(url.charAt(url.length-1))){
            setImageIconUse(infoRow.icon)
        } else {
            setImageIconUse(null)
        }

    }, [infoRow, url])

    return (
        <ThemeProvider theme={theme}>
            <List component="nav" aria-label="main mailbox folders" className={isMobile ? classes.noSpacesMobile : classes.noSpaces }>
                <ListItemLink
                    onClick={changeUrl}
                    className={classes.color}
                >
                    {imageIconUse &&
                    (<ListItemIcon>
                        <img
                            src={`${imageIconUse}`}
                            className={classes.imageIcon}
                            alt="iconos"
                        />
                    </ListItemIcon>)
                    }
                    <ListItemText
                        color={theme.palette.secondary}
                        primary={infoRow.title}
                    />
                    {
                        infoRow.score === "9" && url!=='/' ?
                            (<IconButton edge="end" aria-label="delete">
                                <StarIcon color="primary"/>
                            </IconButton>) :
                            (<IconButton edge="end" aria-label="delete">
                                <ArrowRightIcon color="primary"/>
                            </IconButton>)
                    }
                </ListItemLink>
                <Divider/>
            </List>
        </ThemeProvider>
    );
}

MainTitleBox.propTypes = {
    infoRow: PropTypes.object.isRequired,
}

export default MainTitleBox
